import { ObjectValuesPipe } from './object-values.pipe';

export const OBJECT_VALUES_PIPE_DECLARATIONS = [ObjectValuesPipe];

export * from './object-values.pipe';
